import { AccordionSummary } from '@volvo-cars/react-accordion';
import React from 'react';

/**
 * Renders a question component for an accordion.
 * @param props - The props for the Question component.
 * @returns The rendered Question component.
 */
const Question: React.FC<
  React.PropsWithChildren & React.HTMLAttributes<HTMLElement>
> = ({ children, ...props }) => (
  <AccordionSummary {...props}>{children}</AccordionSummary>
);

export default Question;
